// extracted by mini-css-extract-plugin
module.exports = {"stub":"stub_stub__1-kwr"};